import { NgModule } from "@angular/core";
import { PremiumSortPipe } from "./premium-sort.pipe";

@NgModule({
  imports: [],
  declarations: [
    PremiumSortPipe,
  ],
  exports: [
    PremiumSortPipe,
  ]
})

export class PipeModule {}
